import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronRight } from '@travel-frontend/icons';
import { forwardRef } from 'react';
import { Link } from '../../../../components/Hotel/Box/ArrowActionLink/components/Link.js';
export const ArrowActionLink = forwardRef(({
  children,
  ...rest
}, ref) => {
  return _jsxs(Link, {
    ref: ref,
    ...rest,
    children: [children, _jsx(IconChevronRight, {})]
  });
});